// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

export const authTokenEndPoint = "/api/oauth/token";
export const authTokensEndPoint = "/api/oauth/tokens/:tokenid";
export const authAccountEndPoint = "/api/users/account";
export const authProfileEndPoint = "/api/users/profile";

export const clientId = import.meta.env.VITE_APP_CLIENT_ID;
export const clientSecret = import.meta.env.VITE_APP_CLIENT_SECRET;
